import { useCallback } from 'react';

const MEDIA_ITEMS = [
  {
    title: '《封神第二部》终极预告',
    duration: '02:34',
    views: '128万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20film%20trailer%20thumbnail%20with%20mythological%20Chinese%20warriors%20in%20dramatic%20battle%20scene%2C%20cinematic%20golden%20lighting%20with%20dark%20epic%20atmosphere%2C%20film%20promotional%20visual%20with%20ancient%20Chinese%20aesthetic%20and%20modern%20cinematography&width=600&height=340&seq=media-01&orientation=landscape',
  },
  {
    title: '《大江大河3》精彩花絮',
    duration: '05:18',
    views: '96万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20behind%20the%20scenes%20thumbnail%20with%20vintage%201980s%20setting%2C%20warm%20nostalgic%20lighting%20and%20industrial%20backdrop%2C%20television%20production%20atmosphere%20with%20film%20crew%20and%20cameras%2C%20documentary%20style%20visual&width=600&height=340&seq=media-02&orientation=landscape',
  },
  {
    title: '《狂飙2》先导片段曝光',
    duration: '01:52',
    views: '203万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20television%20promo%20thumbnail%20with%20dramatic%20noir%20lighting%2C%20dark%20urban%20night%20scene%20with%20police%20and%20suspense%20atmosphere%2C%20cinematic%20crime%20drama%20visual%20with%20mysterious%20shadowy%20figures%2C%20high%20contrast%20film%20aesthetic&width=600&height=340&seq=media-03&orientation=landscape',
  },
  {
    title: '暑期档必看片单大盘点',
    duration: '08:15',
    views: '67万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20movie%20marathon%20thumbnail%20with%20collage%20of%20film%20stills%20and%20cinema%20elements%2C%20bright%20warm%20summer%20vibes%20with%20popcorn%20and%20tickets%2C%20entertainment%20showcase%20atmosphere%20with%20vibrant%20colors%20on%20dark%20backdrop%2C%20fun%20movie%20night%20aesthetic&width=600&height=340&seq=media-04&orientation=landscape',
  },
];

export default function SectionMedia() {
  const handleImgError = useCallback((e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.setAttribute('data-failed', 'true');
  }, []);

  return (
    <section id="media" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
            精彩视频
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            预告片、花絮、片单盘点，精彩内容一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {MEDIA_ITEMS.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-300/40 hover:border-background-300/70 transition-all cursor-pointer"
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={handleImgError}
                />
                <div className="absolute inset-0 bg-background-50/20 group-hover:bg-background-50/40 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-background-900/80 text-foreground-50 text-xs font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-2">
                  <i className="ri-eye-line text-foreground-600 text-xs"></i>
                  <span className="text-xs text-foreground-600">{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}